// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar__1Djya","sidebar-text":"styles_sidebar-text__1_B8l","title":"styles_title__3s4ms","subtitle":"styles_subtitle__2kKjp"};